export var Permissions = {
  User: {
    Create: 'Permissions.User.Create',
  },
  Settings: {
    Permissions: 'Permissions.Settings.Permissions',
  },
  Manuals: {
    Full: 'Permissions.Manuals.Full',
  },
  Laboratory: {
    Full: 'Permissions.Laboratory.Full',
  },
};
